const openLink = (link, print = false) => {
    let openedWindow = window.open(link);
    if (print) {
        openedWindow.print();
    }
};

export default openLink;
